import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css'; 

function ContactUs() {
  const navigate = useNavigate();

  return (
    <div className="home-wrapper bg-surface min-h-screen">
      {/* HEADER */}
      <header className="modern-header">
        <div className="container header-flex">
          <div className="brand-box flex-center cursor-pointer" onClick={() => navigate('/')}>
            <img src="/logo.png" alt="Logo" className="nav-logo" onError={(e) => e.target.style.display='none'} />
            
          </div>
          <button className="btn-action-outline" onClick={() => navigate('/')}>← Back to Home</button>
        </div>
      </header>

      {/* MAIN CONTENT */}
      <main className="section-padding">
        <div className="container">
          <div className="card-editorial border-left-highlight" style={{ maxWidth: '1000px', margin: '0 auto', borderLeftColor: '#344abe' }}>
            <h1 className="section-title-large mb-4">Contact Us</h1>
            <p className="text-subtitle mb-10">Get in touch with the Management Committee for any inquiries, support, or assistance.</p>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem', alignItems: 'start' }}>
              
              {/* Contact Details Column */}
              <div className="contact-details-box">
                <h3 className="section-title mb-6" style={{ fontSize: '1.5rem' }}>Get In Touch</h3>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                  
                  <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-start' }}>
                    <div className="icon-box-primary" style={{ width: '45px', height: '45px', flexShrink: 0 }}>📍</div>
                    <div>
                      <strong style={{ display: 'block', color: '#121c2c', marginBottom: '5px' }}>Address</strong>
                      <span style={{ color: '#444653', lineHeight: '1.5' }}>Housefed Colony,<br/>Bathinda, Punjab, India 151001</span>
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-start' }}>
                    <div className="icon-box-primary" style={{ width: '45px', height: '45px', flexShrink: 0 }}>📱</div>
                    <div>
                      <strong style={{ display: 'block', color: '#121c2c', marginBottom: '5px' }}>Mobile & WhatsApp</strong>
                      <span style={{ color: '#444653' }}>+91 9872348700</span>
                      <p style={{ fontSize: '0.8rem', color: '#757685', margin: '5px 0 0 0' }}>(Office of the General Secretary)</p>
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-start' }}>
                    <div className="icon-box-primary" style={{ width: '45px', height: '45px', flexShrink: 0 }}>✉️</div>
                    <div>
                      <strong style={{ display: 'block', color: '#121c2c', marginBottom: '5px' }}>Email Address</strong>
                      <span style={{ color: '#444653' }}>bhcchbs@gmail.com</span>
                    </div>
                  </div>

                </div>
              </div>

              {/* Map Column */}
              <div className="map-container" style={{ width: '100%', height: '100%', minHeight: '350px' }}>
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13796.965654558844!2d74.91655758714634!3d30.173097111244342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39172d3f8b26daa9%3A0x54bcb4ed8c256a87!2sHousefed%20Colony%2C%20Bathinda%2C%20Punjab%20151001%2C%20India!5e0!3m2!1sen!2sus!4v1767715419946!5m2!1sen!2sus" 
                  width="100%" 
                  height="100%" 
                  style={{ border: 0, borderRadius: '16px', minHeight: '350px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }} 
                  allowFullScreen="" 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade" 
                  title="Housefed Colony Location">
                </iframe>
              </div>

            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default ContactUs;